import React from "react";

export default function PoliUmum() {
  return (
    <table className="table-auto w-full lg:w-5/6  text-center my-3 mb-12">
      <thead>
        <tr className=" border">
          <th className="border border-slate-300 p-2">Hari</th>
          <th className="border border-slate-300 p-2">Pukul</th>
          <th className="border border-slate-300 p-2">Nama</th>
        </tr>
      </thead>
      <tbody>
        <tr className="">
          <td className="border border-slate-300 p-1">Senin</td>
          <td className="border border-slate-300 p-1">08.00 - 21.00</td>
          <td className="border border-slate-300 p-1">
            dr. Citra Ayu Merilasari
          </td>
        </tr>

        <tr>
          <td className="border border-slate-300 p-1">Selasa</td>
          <td className="border border-slate-300 p-1">08.00 - 21.00</td>
          <td className="border border-slate-300 p-1">
            dr. Citra Ayu Merilasari
          </td>
        </tr>

        <tr className="">
          <td className="border border-slate-300 p-1">Rabu</td>
          <td className="border border-slate-300 p-1">08.00 - 21.00</td>
          <td className="border border-slate-300 p-1">
            dr. Citra Ayu Merilasari{" "}
          </td>
        </tr>
        <tr>
          <td className="border border-slate-300 p-1">Kamis</td>
          <td className="border border-slate-300 p-1">08.00 - 21.00</td>
          <td className="border border-slate-300 p-1">
            {" "}
            dr. Citra Ayu Merilasari
          </td>
        </tr>
        <tr className="">
          <td className="border border-slate-300 p-1">Jumat</td>
          <td className="border border-slate-300 p-1">08.00 - 21.00</td>
          <td className="border border-slate-300 p-1">
            dr. Citra Ayu Merilasari
          </td>
        </tr>
        <tr>
          <td className="border border-slate-300 p-1">Sabtu</td>
          <td className="border border-slate-300 p-1">08.00 - 21.00</td>
          <td className="border border-slate-300 p-1">dr. Teuku Taharuddin</td>
        </tr>
        <tr className="">
          <td className="border border-slate-300 p-1">Minggu</td>
          <td className="border border-slate-300 p-1">08.00 - 21.00</td>
          <td className="border border-slate-300 p-1">dr. Firman Kurnianto</td>
        </tr>
      </tbody>
    </table>
  );
}
